/** FIN-03 §5 field 9's currency list — the slice's pick list. */
export const CURRENCIES = ['USD', 'EUR', 'GBP', 'AED', 'SAR', 'ILS'] as const;

/**
 * MD-01 field 27's usual ways money moves. Stored as text per the contract;
 * the canonical English strings are the stored values, the keys their labels.
 */
export const PAYMENT_METHODS = ['Cash', 'Card', 'Bank transfer', 'Check', 'Online'] as const;

const METHOD_KEYS: Readonly<Record<string, string>> = {
  Cash: 'partners.methodCash',
  Card: 'partners.methodCard',
  'Bank transfer': 'partners.methodBank',
  Check: 'partners.methodCheck',
  Online: 'partners.methodOnline',
};

/** i18n key for a stored method, or undefined for free text from elsewhere. */
export function partnerMethodKey(method: string): string | undefined {
  return METHOD_KEYS[method];
}
